import React, { useEffect, useState } from 'react'
import GetStaff from '../../services/GetStaffServices';
import { useLocation } from 'react-router-dom';
import UpdateQuestionServices from '../../services/UpdateQuestionServices';
import Swal from 'sweetalert2';
import GetTypeActually from '../../services/GetTypeActually';


const UserStatsLayout = ({ totalUsers, activeUsers, socketRef }) => {
    const location = useLocation();
    const [isAdmin, setIsAdmin] = useState(false)
    const [loading, setLoading] = useState(false); // Estado para controlar la animación de carga
    const [selectedUser, setSelectedUser] = useState('');
    const [dataTypeEvent, setDataTypeEvent] = useState([]);

    const token = sessionStorage.getItem('token');

    useEffect(() => {
        const getStaffs = async () => {
            try {
                const response = await GetStaff(token);

                // Suponemos que el email está guardado en sessionStorage con la clave "email"
                const storedEmail = sessionStorage.getItem("email");

                if (response.emails.includes(storedEmail)) {
                    setIsAdmin(true)
                } else {
                    setIsAdmin(false);
                }
            } catch (error) {
                console.error("Error al obtener los staffs:", error);
            }
        };

        getStaffs();
    }, [token]);

    // Nueva función para manejar el clic en el botón
    const handleTriggerClick = async () => {
        if (location.pathname === '/inicio') {
            setLoading(true); // Activar el loading

            // Enviar el trigger al socket
            socketRef.current.emit('trigger_modal');

            // Simulación de espera de 10 segundos (10000 ms)
            await new Promise(resolve => setTimeout(resolve, 10000));

            setLoading(false); // Desactivar el loading
        } else if (location.pathname === '/chatLive') {
            setLoading(true); // Activar el loading

            // Enviar el trigger al socket
            socketRef.current.emit('trigger_modal');

            // Simulación de espera de 10 segundos (10000 ms)
            await new Promise(resolve => setTimeout(resolve, 10000));

            setLoading(false); // Desactivar el loading
        }
    };


    const handleCloseModal = async () => {
        if (location.pathname === '/inicio') {
            setLoading(true); // Activar el loading

            // Enviar el trigger al socket
            socketRef.current.emit('trigger_close_modal');

            // Simulación de espera de 10 segundos (10000 ms)
            await new Promise(resolve => setTimeout(resolve, 10000));

            setLoading(false); // Desactivar el loading
        } else if (location.pathname === '/chatLive') {
            setLoading(true); // Activar el loading

            // Enviar el trigger al socket
            socketRef.current.emit('trigger_close_modal');

            // Simulación de espera de 10 segundos (10000 ms)
            await new Promise(resolve => setTimeout(resolve, 10000));

            setLoading(false); // Desactivar el loading
        }
    }

    const handleChange = async (event) => {
        const value = event.target.value;
        setSelectedUser(value); // Actualiza el estado con el valor seleccionado

        try {
            const response = await UpdateQuestionServices(token, value);

            if (response === 200) {
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Las preguntas fueron cambiadas correctamente',
                    showConfirmButton: false,
                    timer: 1500,
                    toast: true, // Para que aparezca como un toast
                });
            } else {
                Swal.fire({
                    position: 'top-end',
                    icon: 'error',
                    title: 'Ocurrio un error al cambiar las preguntas',
                    showConfirmButton: false,
                    timer: 1500,
                    toast: true, // Para que aparezca como un toast
                });
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        const typeQuestions = async () => {
            try {
                const response = await GetTypeActually(token);

                setDataTypeEvent(response)
            } catch (error) {
                throw new Error(error);
            }
        }

        typeQuestions();
    }, []);

    return (
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-5">
            <div class="flex flex-col space-y-4">
                <div class="bg-white shadow-md rounded-lg p-4 flex items-center">
                    <div class="text-blue-500 mr-4">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-12 w-12">
                            <path d="M5.25 6.375a4.125 4.125 0 1 1 8.25 0 4.125 4.125 0 0 1-8.25 0ZM2.25 19.125a7.125 7.125 0 0 1 14.25 0v.003l-.001.119a.75.75 0 0 1-.363.63 13.067 13.067 0 0 1-6.761 1.873c-2.472 0-4.786-.684-6.76-1.873a.75.75 0 0 1-.364-.63l-.001-.122ZM18.75 7.5a.75.75 0 0 0-1.5 0v2.25H15a.75.75 0 0 0 0 1.5h2.25v2.25a.75.75 0 0 0 1.5 0v-2.25H21a.75.75 0 0 0 0-1.5h-2.25V7.5Z" />
                        </svg>
                    </div>
                    <div class="flex flex-col">
                        <h2 class="text-sm font-semibold">Usuarios Registrados</h2>
                        <div class="flex items-center text-gray-600 text-md">
                            <p>{totalUsers}</p>
                        </div>
                    </div>
                </div>

                <div class="bg-white shadow-md rounded-lg p-4 flex items-center">
                    <div class="text-green-500 mr-4">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-12 w-12">
                            <path fill-rule="evenodd" d="M8.25 6.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0ZM15.75 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM2.25 9.75a3 3 0 1 1 6 0 3 3 0 0 1-6 0ZM6.31 15.117A6.745 6.745 0 0 1 12 12a6.745 6.745 0 0 1 6.709 7.498.75.75 0 0 1-.372.568A12.696 12.696 0 0 1 12 21.75c-2.305 0-4.47-.612-6.337-1.684a.75.75 0 0 1-.372-.568 6.787 6.787 0 0 1 1.019-4.38Z" clip-rule="evenodd" />
                            <path d="M5.082 14.254a8.287 8.287 0 0 0-1.308 5.135 9.687 9.687 0 0 1-1.764-.44l-.115-.04a.563.563 0 0 1-.373-.487l-.01-.121a3.75 3.75 0 0 1 3.57-4.047ZM20.226 19.389a8.287 8.287 0 0 0-1.308-5.135 3.75 3.75 0 0 1 3.57 4.047l-.01.121a.563.563 0 0 1-.373.486l-.115.04c-.567.2-1.156.349-1.764.441Z" />
                        </svg>
                    </div>
                    <div class="flex flex-col">
                        <h2 class="text-sm font-semibold">En el Evento</h2>
                        <div class="flex items-center text-gray-600 text-md">
                            <p>{activeUsers}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex flex-col items-center">
                <label htmlFor="user-select" className="text-sm font-semibold mb-1 text-white text-center">
                    Cambiar Preguntas Modal:
                </label>
                <p className='text-white'>Valor Actual</p>
                <select
                    id="user-select"
                    value={selectedUser} // Valor del select controlado
                    onChange={handleChange} // Captura el cambio
                    className="block w-full border-gray-300 rounded-md shadow-sm focus:ring focus:ring-purple-500 focus:border-purple-500 text-sm"
                >

                    {dataTypeEvent && (
                        <>
                            {/* Primero muestra el valor activo */}
                            <option value={dataTypeEvent.active_type_question} selected>
                                {dataTypeEvent.active_type_question}
                            </option>

                            {/* Muestra el valor inactivo */}
                            <option value={dataTypeEvent.inactive_type_question}>
                                {dataTypeEvent.inactive_type_question}
                            </option>
                        </>
                    )}
                </select>

                <div className="flex justify-center items-center h-full mt-4">
                    {isAdmin && (
                        <>
                            <button
                                onClick={handleTriggerClick}
                                disabled={loading}
                                className={`bg-blue-500 text-white font-bold py-2 px-4 rounded ${loading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-700'}`}
                            >
                                {loading ? 'Cargando...' : 'Abrir Modal'}
                            </button>

                            <button
                                onClick={handleCloseModal}
                                disabled={loading}
                                className={`bg-red-500 text-white font-bold py-2 px-4 rounded mx-3 ${loading ? 'opacity-50 cursor-not-allowed' : 'hover:bg-blue-700'}`}
                            >
                                {loading ? 'Cargando...' : 'Cerrar modal'}
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>

    )
}

export default UserStatsLayout;